import { useEffect } from 'react';
import { getDomain } from '../utils/urls';
import { useQueryData } from './useQueryData';
import { useState } from 'react';
// @ts-expect-error - JS file
import { disableHubSpotCookieBanner } from '../utils/disableHubSpotCookieBanner';
import { setLoginMetadataCookieEnableAll } from '../utils/cookies';
export const useMobileReauthCookie = () => {
  const [isMobileLogin, setIsMobileLogin] = useState(false);
  const {
    allQueryParams
  } = useQueryData();
  const reauth = allQueryParams.reauth;
  useEffect(() => {
    if (reauth) {
      const expires = new Date();
      expires.setTime(expires.getTime() + 10 * 60 * 1000);
      const reauthCookie = Array.isArray(reauth) ? reauth[0] : reauth;
      document.cookie = `hs_reauth=${reauthCookie}; path=/; secure; domain=${getDomain()}; expires=${expires.toUTCString()}`;
      setLoginMetadataCookieEnableAll();
      disableHubSpotCookieBanner();
      setIsMobileLogin(true);
    } else {
      setIsMobileLogin(false);
    }
  }, [reauth]);
  return isMobileLogin;
};